import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../styles/Home.css';

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Alltagsbegleitung mit Herz – Catrin Kaßner',
  description: 'Alltagsbegleitung für Senioren in Jena: Gesellschaft, Haushaltshilfe, Begleitdienste und Unterstützung bei Behördengängen.',
  url: 'https://www.alltagsbegleitung-ckassner.de',
  telephone: '+4917666617760',
  email: 'info@alltagsbegleitung-ckassner.de',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Wilhelm-Külz-Straße 6',
    addressLocality: 'Jena',
    postalCode: '07743',
    addressCountry: 'DE',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday'],
      opens: '08:00',
      closes: '18:00',
    },
  ],
  areaServed: { '@type': 'City', name: 'Jena' },
  priceRange: '€€',
};

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Alltagsbegleitung Jena | Catrin Kaßner – Seniorenbetreuung</title>
        <meta name="description" content="Alltagsbegleitung für Senioren in Jena. Catrin Kaßner bietet Gesellschaft, Haushaltshilfe und Begleitdienste. Kostenloses Erstgespräch – jetzt anfragen!" />
        <link rel="canonical" href="https://www.alltagsbegleitung-ckassner.de/" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <div className="page-background home-background"></div>
      <div className="home">
        <section className="hero">
          <div className="hero-content">
            <h1>Alltagsbegleitung mit Herz<br />in Jena</h1>
            <p>Individuelle Unterstützung und fürsorgliche Begleitung im Alltag, die das Leben Ihrer Angehörigen bereichert.</p>
            <Link to="/contact" className="cta-button">
              Kostenlose Beratung
            </Link>
          </div>
        </section>

        <section className="features">
          <h2>Meine Betreuungsleistungen</h2>
          <div className="features-grid">
            <div className="feature-card">
              <i className="fas fa-home"></i>
              <h3>Gesellschaft</h3>
              <p>Regelmäßige Besuche und bedeutungsvolle Gespräche</p>
            </div>
            <div className="feature-card">
              <i className="fas fa-hands-helping"></i>
              <h3>Tägliche Unterstützung</h3>
              <p>Hilfe bei alltäglichen Aufgaben</p>
            </div>
            <div className="feature-card">
              <i className="fas fa-heart"></i>
              <h3>Emotionale Unterstützung</h3>
              <p>Einfühlsame und mitfühlende Betreuung</p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
